import { Link } from "react-router-dom";
import logo from "@/assets/logo.webp";

const Footer = () => {
  return (
    <footer className="bg-navy-dark text-paper/70 pt-16 sm:pt-20 lg:pt-24 pb-[calc(3rem+var(--safe-bottom))] px-6 md:px-12 lg:px-24 px-safe border-t border-white/10 isolate">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 sm:gap-12 md:gap-16 mb-12 sm:mb-16 md:mb-24">
        <div className="md:col-span-1">
          <Link to="/" className="inline-block mb-6" aria-label="JIC — Home">
            <img src={logo} alt="JSA Investment Club logo" className="h-12 w-auto [filter:brightness(0)_invert(1)] opacity-80" width={48} height={48} />
          </Link>
          <p className="text-sm leading-relaxed text-paper/70 mb-6 max-w-xs">
            A student-run investment organization at Jönköping International
            Business School, dedicated to developing future financial leaders.
          </p>
          <div className="flex gap-4">
            <a
              href="https://www.linkedin.com/company/jsa-investment-club/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="inline-flex items-center justify-center w-11 h-11 -m-2 text-paper/60 hover:text-steel-light transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/jsainvestmentclub/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="inline-flex items-center justify-center w-11 h-11 -m-2 text-paper/60 hover:text-steel-light transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-paper text-[10px] font-bold uppercase tracking-[0.25em] mb-6">
            Navigation
          </h3>
          <ul className="space-y-1 text-sm text-paper/70">
            {[
              { label: "About", href: "/about" },
              { label: "Activities", href: "/activities" },
              { label: "Benefits", href: "/benefits" },
              { label: "Insights", href: "/insights" },
              { label: "Portfolio", href: "/portfolio" },
              { label: "Team", href: "/team" },
              { label: "Contact", href: "/contact" },
              { label: "Apply", href: "/apply" },
            ].map((l) => (
              <li key={l.label}>
                <Link
                  to={l.href}
                  className="inline-flex items-center min-h-[44px] hover:text-paper transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}

          </ul>
        </div>

        <div>
          <h3 className="text-paper text-[10px] font-bold uppercase tracking-[0.25em] mb-6">
            Resources
          </h3>
          <ul className="space-y-1 text-sm text-paper/70">
            <li><Link to="/brand" className="inline-flex items-center min-h-[44px] hover:text-paper transition-colors">Brand Kit</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-paper text-[10px] font-bold uppercase tracking-[0.25em] mb-6">
            Contact
          </h3>
          <ul className="space-y-1 text-sm text-paper/70">
            <li>
              <a
                href="mailto:investmentclub.jsa@js.ju.se"
                className="inline-flex items-center min-h-[44px] hover:text-paper transition-colors"
              >
                investmentclub.jsa@js.ju.se
              </a>
            </li>
            <li>
              Jönköping University
              <br />
              Gjuterigatan 5
              <br />
              553 18 Jönköping, Sweden
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-[10px] uppercase tracking-[0.2em] text-paper/60">
        <p>
          © 2026 JSA. All rights reserved. Developed by{" "}
          <a
            href="https://www.linkedin.com/in/erikwester/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-paper transition-colors underline underline-offset-2"
          >
            Erik Wester
          </a>
        </p>
        <div className="flex gap-6 sm:gap-8 overflow-x-auto no-scrollbar">
          <Link to="/brand" className="inline-flex items-center min-h-[44px] hover:text-paper transition-colors">Brand Kit</Link>
          <a href="mailto:investmentclub.jsa@js.ju.se" className="inline-flex items-center min-h-[44px] hover:text-paper transition-colors">Contact Us</a>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
